import React, { PureComponent } from "react";
import {
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
  BarChart,
  Bar,
  Legend,
  Tooltip,
  ReferenceLine
} from "recharts";
import styles from "./Charts.local.scss";
import {
  CustomizedXAxisTickRotated,
  CustomizedYAxisTick,
  CustomTooltip
} from "./Common";

import Brush from "recharts/lib/cartesian/Brush";

const colors = [
  "#2495E1",
  "#73B7FF",
  "#F84154",
  "#FE5C3D",
  "#FA9437",
  "#D0A679",
  "#06d9b1",
  "#95FFD7",
  "#F7953E"
];

export class StackedBarChart extends PureComponent {
  render() {
    const {
      chartData,
      dataKeysY,
      currency,
      legendLabels,
      tooltipValueFormat
    } = this.props;
    return (
      <ResponsiveContainer
        width={"95%"}
        height={500}
        className={styles.charts_font}
      >
        <BarChart
          data={chartData}
          margin={{
            top: 15,
            right: 40,
            left: 15,
            bottom: 80,
            position: "absolute"
          }}
          style={{ position: "absolute" }}
        >
          <CartesianGrid vertical={false} stroke="#6d7f92" strokeWidth={0.2} />
          <XAxis
            name={"label"}
            dataKey={"label"}
            height={50}
            interval={0}
            padding={{ left: 20, right: 20 }}
            type="category"
            tick={<CustomizedXAxisTickRotated />}
          />
          <YAxis
            tick={<CustomizedYAxisTick currency={currency} />}
            axisLine={false}
            tickLine={false}
            type={"number"}
          />
          <Tooltip
            cursor={{ fill: "#f3faff", opacity: 0.6 }}
            content={<CustomTooltip format={tooltipValueFormat} />}
          />
          <Legend
            verticalAlign="top"
            height={70}
            iconType={"square"}
            iconSize={12}
            wrapperStyle={{
              left: 42,
              top: 0,
              fontWeight: 300,
              fontSize: "14px"
            }}
          />
          <ReferenceLine y={0} stroke="#6d7f92" />
          <Brush
            dataKey="label"
            endIndex={chartData.length > 20 ? 20 : chartData.length - 1}
            height={30}
            stroke="#2495E1"
            y={470}
          />
          {dataKeysY.map((item, i) => {
            return (
              <Bar
                key={i}
                name={legendLabels[i]}
                type="monotone"
                dataKey={dataKeysY[i]}
                barSize={60}
                radius={[1, 1, 1, 1]}
                fill={colors[i]}
                animationEasing={"ease-in-out"}
                animationDuration={800}
                minPointSize={3}
                stackId={dataKeysY[i].search("real") === -1 ? "b" : "a"}
              />
            );
          })}
        </BarChart>
      </ResponsiveContainer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Common/Charts/StackedBarChart.js